import { AnimatePresence } from 'framer-motion';
import { IAppError, IServerError } from '../../../errors';
import { IVisibleGameState } from '../../../Models/StateModels';
import ErrorToast from './ErrorToast';

const MAX_VISIBLE_TOASTS = 3;

interface IErrorsProps {
  errors: IAppError[];
  visibleGameState: IVisibleGameState | undefined;
  removeError: (id: string) => void;
}

function playerName(
  playerIndex: number,
  visibleGameState: IVisibleGameState | undefined
) {
  return visibleGameState?.opponents.find((o) => o.playerIndex === playerIndex)
    ?.name;
}

function describeError(
  error: IServerError,
  visibleGameState: IVisibleGameState | undefined
) {
  if (error.code === 'NotYourTurn' && error.playerIndex !== undefined) {
    const name = playerName(error.playerIndex, visibleGameState);
    return name ? `It's ${name}'s turn.` : error.message;
  }
  return error.message;
}

export default function Errors({
  errors,
  visibleGameState,
  removeError,
}: IErrorsProps) {
  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-0 z-70 flex flex-col items-center gap-[8px] px-[16px] pt-[max(12px,env(safe-area-inset-top))]"
    >
      <AnimatePresence initial={false}>
        {errors.slice(-MAX_VISIBLE_TOASTS).map((error) => (
          <ErrorToast
            key={error.id}
            error={error}
            text={describeError(error, visibleGameState)}
            onDismiss={removeError}
          />
        ))}
      </AnimatePresence>
    </div>
  );
}
